import React from "react";
import { type DropdownWithoutOptionsProps } from "../models";
import BaseReactSelectDropdown from "./BaseReactSelectDropdown";

const PickupLocationTypeDropdown = (props: DropdownWithoutOptionsProps<server.dto.PickupLocationType, server.dto.PickupLocationTypes>) => {
  return <BaseReactSelectDropdown
    excludeKeys={props.excludeKeys}
    options={serverReference.pickupLocationTypes}
    getLabel={p => p.text}
    getValue={(t) => t.value}
    value={props.value}
    onChange={props.onChange}
    onEsc={props.onEsc}
    config={props.config}
  />;
};

export default PickupLocationTypeDropdown;